var Backbone = require('backbone');


var ReviewElementStatusesCollection = Backbone.Model.extend({
    url:"/api/document/statuses"
});


module.exports = ReviewElementStatusesCollection;


//////////////////
// WEBPACK FOOTER
// ./app/models/review-element-statuses-model.js
// module id = 209
// module chunks = 0